import { CompetitionInput as CompetitionInputComponent } from './CompetitionInput.component'
import { connector } from './CompetitionInput.connector';

export const CompetitionInput = connector(CompetitionInputComponent);
